import type { ISerialize } from '@/objects/ISerialize';
import { LicenceSearchItem } from './LicenceSearchItem';
import { ParticipantWithLicences } from './ParticipantWithLicences';

export class ParticipantLicenceResponse implements ISerialize {
    public Licences: LicenceSearchItem[];

    public Participants: ParticipantWithLicences[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Licences?: LicenceSearchItem[]; Participants?: ParticipantWithLicences[] }) {
        this.Licences = values.Licences ?? [];

        this.Participants = values.Participants ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"Licences": [ ${this.Licences.map((x) => (!x ? null : x?.serialize()))} ]` +
            ',' +
            `"Participants": [ ${this.Participants.map((x) => (!x ? null : x?.serialize()))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of ParticipantLicenceResponse from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Licences?: LicenceSearchItem[];
        Participants?: ParticipantWithLicences[];
    }): ParticipantLicenceResponse {
        return new ParticipantLicenceResponse(values);
    }

    public static _FromServerJson(json: any): ParticipantLicenceResponse {
        return new ParticipantLicenceResponse({
            Licences: json.Licences?.map((x: any) => LicenceSearchItem._FromServerJson(x)),
            Participants: json.Participants?.map((x: any) => ParticipantWithLicences._FromServerJson(x)),
        });
    }

    /**
     * Creates an instance of ParticipantLicenceResponse from another instance of ParticipantLicenceResponse.
     * @param other The ParticipantLicenceResponse you want to clone
     * @returns A cloned ParticipantLicenceResponse
     */
    public static FromOther(other: ParticipantLicenceResponse): ParticipantLicenceResponse {
        return ParticipantLicenceResponse._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ParticipantLicenceResponse.FromOther(this);
    }

    static NAME_OF_CLASS = 'ParticipantLicenceResponse';
}
